import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-hot-toast";
import { Route, useNavigate } from "react-router-dom";
import { LOGIN_API, REFRESH_API } from "src/config/apiConfig";
import { AuthRequest } from "src/models/authentication/auth";
import { NavigateFunction } from 'react-router-dom';

export const handleLoginThunk = createAsyncThunk(
  'auth/handleLoginThunk',
  async ({ payload, navigate }: { payload: AuthRequest, navigate: NavigateFunction }, thunkAPI) => {
    try {
      const response = await axios.post(LOGIN_API, payload);
      console.log(response)
      if (response.data.status === 200) {
        toast.success(response.data.message);
        navigate('/dashboards/home');
      } else {
        toast.error(response.data.message);
      }

      return { data: response.data };
    } catch (error: any) {
      console.log(error)
      toast.error(error.response?.data?.Message || error.response?.data?.message || "Terjadi Kesalahan");
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const refreshTokenThunk = createAsyncThunk(
  'auth/refreshToken',
  async (refreshToken: string, thunkAPI) => {
    try {
      const response = await axios.post(REFRESH_API, { refreshToken });
      
      if (response.status === 200) {
        // toast.success("Token refreshed successfully");
        return response.data;
      } else {
        toast.error("Not authenticated");
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (error: any) {
      toast.error(error.response?.data?.errorMessage || 'Please Re-Login');
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const handleLoginSsoThunk = createAsyncThunk('auth/handleLoginSsoThunk', async (payload) => {
  const user = JSON.parse(localStorage.getItem('userData') as any);
  return {
    data: user
  }
})
